<template>
    <div id="order-details">
        <div class="field">
            <label class="label">Method</label>
            <div class="service-type-section">
                <ServiceTypeChooser :showAddressChooser="true"/>
            </div>
        </div>
        <hr>
        <!-- Time Chooser -->
        <BaseDatePicker/>
        <v-dialog/>
    </div>
</template>


<script>
	import ServiceTypeChooser from "@/components/checkout/ServiceTypeChooser"
    import { mapGetters, mapActions } from 'vuex';
    import { ACCOUNT_CHECKOUT } from '@/stores/defs';
import { EServiceType } from '@/models/interfaces/Orders/EServiceType';

export default {
    components: {
        ServiceTypeChooser
    },
    computed: {
        ...mapGetters({
            deliveryAddress: ACCOUNT_CHECKOUT.GET_DELIVERY_ADDRESS,
            serviceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE
        })
    },
    methods: {
        ...mapActions({
            setServiceType: ACCOUNT_CHECKOUT.SET_SERVICE_TYPE
        })
    },
    beforeDestroy() {
        // no address set, set to pickup
        if (this.serviceType === EServiceType.SERVICE_TYPE_DELIVERY && !this.deliveryAddress) {
            this.setServiceType(EServiceType.SERVICE_TYPE_TAKEOUT)
        }
    }
};
</script>

<style lang="scss">
	@import 'globalStyles';
    #order-details {
        padding: 1em;
    }
    .service-type-section {
        padding-top: 1em;
    }

    @include desktop {
        #order-details {
            padding: 2em;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/orders/OrderDetails.vue